import React, { Component } from 'react';
import BaseLayout from './../../templates/base'
import UserEditForm from './../../elements/users/form';
import Loading from "../../elements/loading";
import UsersAdd from '../../elements/users/widget/users_add';

class UserEdit extends Component {
	render() {
		let { users, status, roles, entities } = this.props;
		return (
			users.isFetching || status.isFetching || roles.isFetching || entities.isFetching ? <Loading /> : <UserEditForm {...this.props}/>
		)
	}

	componentWillMount() {
		const { match } = this.props;
		this.props.resetUser();
		this.props.fetchStatus(1);
		this.props.fetchRolesList();
		this.props.fetchEntities();
		this.props.fetchUser(match.params.id);
	}
}

export default BaseLayout(UserEdit, {
	title: `Editar usuario`,
	subnav: {
		icon: 'fa-users',
		name: 'Administración',
		actions: [
			{
				type: 'element',
				url: null,
				name: 'Agregar',
				element: <UsersAdd />
			}
		]
	}
});


// WEBPACK FOOTER //
// ./src/layouts/users/edit.jsx